import { useTranslation } from 'react-i18next';

import { PageLayout, PageTitle } from 'core/components';
import { PartList } from 'parts/components';

export const PartListPage = () => {
  const { t } = useTranslation();

  return (
    <PageLayout title={t('titlePartList')} hasGlobalSearch={false}>
      <>
        <PageTitle title={t('titlePartList')} />

        <PartList />
      </>
    </PageLayout>
  );
};
